// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/map-bg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacts {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 50% -19px;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}
.contacts .overlay_light {
  background-color: rgba(202, 222, 138, 0.88);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}
.contacts .container_contacnts {
  margin: 0 auto;
  max-width: 1200px;
  padding: 0 40px;
  position: relative;
  z-index: 2;
}
.contacts .container_contacnts .title_contacnts {
  display: flex;
  justify-content: center;
}
.contacts .container_contacnts .title_contacnts h3 {
  max-width: 800px;
  text-align: center;
  font-family: "Century Gothic";
  font-weight: 300;
  font-size: 1.8rem;
  line-height: 3rem;
}
@media screen and (max-width: 480px) {
  .contacts .container_contacnts .title_contacnts h3 {
    padding: 0 10px;
    font-size: 1.25rem;
    line-height: 1.2em;
  }
}
.contacts .container_contacnts .title_contacnts h3 .span_white {
  color: rgb(255, 255, 255);
  font-weight: 600;
}
.contacts .modal_window[data-visible=true] {
  display: flex;
  justify-content: center;
  align-items: center;
}
.contacts .modal_window[data-visible=true] .modal_form_contact {
  width: 600px;
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
}
.contacts .modal_window[data-visible=true] .modal_form_contact .modal_header {
  height: 30px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.contacts .modal_window[data-visible=true] .modal_form_contact .modal_header .btn_close_contact {
  margin: 5px;
  background: none;
  border: none;
  float: right;
  font-size: 21px;
  font-weight: 700;
  line-height: 1;
  color: rgb(0, 0, 0);
  text-shadow: 0 1px 0 #fff;
  opacity: 0.2;
  cursor: pointer;
}
.contacts .modal_window[data-visible=true] .modal_form_contact .modal_body {
  text-align: center;
  color: rgb(60, 60, 60);
  font-family: "Roboto-Regular";
  font-size: 17px;
  line-height: 3rem;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/ContactsBlock/ContactsBlock.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,yDAAA;EACA,8BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;AACF;AACE;EACE,2CAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;AACJ;AAEE;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AAAJ;AAEI;EACE,aAAA;EAEA,uBAAA;AADN;AAIM;EACE,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAFR;AAIQ;EARF;IASI,eAAA;IACA,kBAAA;IACA,kBAAA;EADR;AACF;AAGQ;EACE,yBAAA;EACA,gBAAA;AADV;AAQE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AANJ;AAQI;EACI,YAAA;EAGA,oCAAA;EACA,mBAAA;AARR;AAUQ;EACI,YAAA;EACA,2CAAA;AARZ;AAUY;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AARhB;AAYQ;EACI,kBAAA;EAEA,sBAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAXZ","sourcesContent":[".contacts {\n  position: relative;\n  background-image: url('../../../public/images/map-bg.webp');\n  background-position: 50% -19px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-attachment: fixed;\n\n  .overlay_light {\n    background-color: rgb(202 222 138 / 88%);\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 1;\n  }\n\n  .container_contacnts {\n    margin: 0 auto;\n    max-width: 1200px;\n    padding: 0 40px;\n    position: relative;\n    z-index: 2;\n\n    .title_contacnts {\n      display: flex;\n      // flex-direction: column;\n      justify-content: center;\n\n\n      h3 {\n        max-width: 800px;\n        text-align: center;\n        font-family: \"Century Gothic\";\n        font-weight: 300;\n        font-size: 1.8rem;\n        line-height: 3rem;\n\n        @media screen and (max-width: 480px) {\n          padding: 0 10px;\n          font-size: 1.25rem;\n          line-height: 1.2em;\n        }\n\n        .span_white {\n          color: rgb(255, 255, 255);\n          font-weight: 600;\n        }\n      }\n    }\n\n  }\n\n  .modal_window[data-visible=\"true\"] {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .modal_form_contact {\n        width: 600px;\n        // margin: 30px auto;\n        // padding: 0 0 20px 0;\n        background-color: rgb(255, 255, 255);\n        border-radius: 10px;\n\n        .modal_header {\n            height: 30px;\n            border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n\n            .btn_close_contact {\n                margin: 5px;\n                background: none;\n                border: none;\n                float: right;\n                font-size: 21px;\n                font-weight: 700;\n                line-height: 1;\n                color: rgb(0, 0, 0);\n                text-shadow: 0 1px 0 #fff;\n                opacity: .2;\n                cursor: pointer;\n            }\n        }\n\n        .modal_body {\n            text-align: center;\n            // padding: 15px;\n            color: rgb(60, 60, 60);\n            font-family: \"Roboto-Regular\";\n            font-size: 17px;\n            line-height: 3rem;\n            font-weight: 600;\n        }\n    }  \n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
